import * as React from "react";
import { Button, Typography } from "@material-ui/core";
import { LocalizerHelper } from "../../helpers/localizerHelper";
import { MenuItemOption } from "../../models";
import { getOptionId } from "../../helpers/menuItemHelper";
import { Remove } from "@material-ui/icons";
import { formatPrice } from "../../helpers/formatHelper";

interface Props {
  onlyRead: boolean;
  menuItemOption: MenuItemOption;
  quantity: number;
  addOption: (option: MenuItemOption) => void;
  removeOption: (option: MenuItemOption) => void;
}

const MenuItemOptionView: React.FC<Props> = ({ menuItemOption, quantity, addOption, removeOption, onlyRead}) => {
  const id = getOptionId(menuItemOption);

  const _plus = () => {
    if(onlyRead) return;
    const max: number = menuItemOption.max_size ?? 1;
    switch(true){
      case (max <= 0):
      case (max > 0 && quantity < max):
        addOption(menuItemOption);
        break;
      case (max > 0 && quantity >= max):
        //do nothing
        break;
    }
  }

  const _minus = (event:React.SyntheticEvent) => {
    if(onlyRead) return;
    event.preventDefault();
    event.stopPropagation();
    if(quantity > 0){
      removeOption(menuItemOption);
    }
  }


  const _buildHeader = () => {
    const name: string|undefined|null = LocalizerHelper.localized(menuItemOption, ['name', 'title'])?.trim() ?? "";
    if(quantity > 0){
      return <span style={{color:"#FE3436"}}>{name}</span>
    }
    return name;
  }

  const _buildSubtitle = () => {
    let subtitle = ` ${LocalizerHelper.localized('max')} (${menuItemOption.max_size ?? 1})`
    return subtitle;
  }

  const _buildPrice = () => {
    switch(true){
      case (quantity <= 0):
        return formatPrice(menuItemOption.price)
      case (quantity == 1):
        return <span style={{color:"#FE3436"}}>{formatPrice(menuItemOption.price)}</span>
      case (quantity > 1):
        return <span style={{color:"#FE3436"}}>{quantity} x {formatPrice(menuItemOption.price)}</span>
    }
  }

  if(!id) return null;

  return (
    <div className="add-on-option">
      <div className="row" onClick={_plus}>
        <div className="col-7">
          <Typography variant="h5" gutterBottom className="option-header" align="left">{_buildHeader()}</Typography>
          <Typography variant="subtitle1" gutterBottom className="option-sub-header" align="left">{_buildSubtitle()}</Typography>
        </div>
        <div className="col-1 vertically-center" style={{padding:"0"}}>
          { (quantity > 0) && 
            <Button className={`qty-action-button`} disabled={onlyRead || quantity<=0} onClick={(event) => {_minus(event)}}>
              <Remove id="minus-button" className="qty-action-button-icon" htmlColor={"#ffffff"} />
            </Button>
          }
            </div> 
            <div className="col-4 text-right vertically-center">
                {_buildPrice()}
            </div>
            <hr />
        </div>
        <hr />
    </div>
);
};

export default MenuItemOptionView;
